export default __webpack_public_path__ + "static/headerBg-90192ea3d6364d906a82a0f670cf97fd.png";